import React, { useState } from "react";
import styled from "styled-components";
import { FaStar } from "react-icons/fa";
import { IoCartOutline, IoHeartOutline } from "react-icons/io5";

const ProductCard = ({ width, product, addToCart, removeFromCart, cart }) => {
  const [isShown, setIsShown] = useState(false);

  return (
    <CardContainer
      width={width}
      product={product}
      onMouseEnter={() => setIsShown(true)}
      onMouseLeave={() => setIsShown(false)}
    >
      <ImageContainer>
        {isShown ? (
          <img
            // src={"./p" + (Math.floor(Math.random() * 10) + 1) + ".png"}
            src={product.img}
            alt="p1"
          />
        ) : (
          <img src={product.img} alt="p1" />
        )}
      </ImageContainer>
      <HoverContainer>
        <IoCartOutline onClick={() => addToCart(product)} />
        <IoHeartOutline />
      </HoverContainer>
      <Name>{product.name}</Name>
      <Price>${product.price}</Price>
      <Rating>
        {Array(product.rating)
          .fill(null)
          .map((_, i) => (
            <FaStar key={i} />
          ))}
        {Array(5 - product.rating)
          .fill(null)
          .map((_, i) => (
            <FaStar style={{ color: "#aaa" }} key={i} />
          ))}
      </Rating>
    </CardContainer>
  );
};

const CardContainer = styled.div`
  overflow: hidden;
  width: ${(props) => props.width};
  padding: 1em;
  display: flex;
  flex-direction: column;
  /* align-items: center; */
  position: relative;
  :hover {
    img {
    }
  }
  img {
    cursor: pointer;
  }
`;
const Name = styled.div`
  font-size: 1.15rem;
  cursor: pointer;
  transition: color 0.5s;
  :hover {
    color: #83aa4c;
  }
`;
const Price = styled.div`
  font-size: 1.3rem;
  margin: 0.5em 0;
  color: #83aa4c;
`;
const Rating = styled.div`
  color: gold;
`;
const ImageContainer = styled.div`
  width: 200px;
  height: 250px;
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;
const HoverContainer = styled.div`
  overflow: hidden;
  margin-left: 16px;
  font-size: 2.5rem;
  z-index: 500;
  display: none;
  position: absolute;
  bottom: 2.5em;
  left: 0;
  animation: slide-in;
  animation-duration: 0.3s;
  @keyframes slide-in {
    0% {
      left: -2em;
    }

    100% {
      left: 0;
    }
  }
  ${CardContainer}:hover & {
    display: block;
  }
  & > * {
    color: grey;
    margin: 0.1em;
    box-shadow: 0 3px 5px #cacaca;
    padding: 0.2em;
    background: #fff;
    transition: color 0.3s, background-color 0.3s;
    cursor: pointer;
    :hover {
      background-color: #83aa4c;
      color: #fff;
    }
  }
`;

export default ProductCard;
